module.exports = __webpack_public_path__ + "media/images/logo-manager-d96518a0d2645fac51e1a2d25905d98f.png";